import decode from "jwt-decode";

export default class User {
  Permissions = [];
  constructor(token, expires, refreshToken) {
    const jwt = decode(token);
    this.token = token;
    this.expires = expires;
    this.refreshToken = refreshToken;
    this.nome = jwt.nome;
    this.email = jwt.email;
    this.perfil = jwt.perfil;
    this.consultorId = jwt.consultorId;
    this.Permissions = jwt.Permissions.split(",");
  }
}
